<template>
  <div class="row border-bottom mb-5 pb-3">
    <div class="col-12">
      <h3>{{$t('modalidades_graph_h3')}}</h3>
    </div>
    <div class="col-12">
      <highcharts class="packedbubble" :options="graphOptions"></highcharts>
    </div>

  </div>
</template>

<style lang="scss">

</style>

<script>

  import { Chart } from 'highcharts-vue'
  import Highcharts from "highcharts"
  import more from 'highcharts/highcharts-more'
  import streamgraph from 'highcharts/modules/streamgraph'
  import { map, filter, groupBy, uniq } from 'lodash'

  more(Highcharts)
  streamgraph(Highcharts)

  export default {
    name: 'modalidadesGraph',
    props: {
      dataset: Array
    },
    components: {
      highcharts: Chart
    },
    data() {
      return {
        fieldSelected: 'anio_aprob'
      }
    },
    computed: {
      graphOptions() {
        return {
          chart: {
            backgroundColor: 'transparent',
            type: 'spline'
          },
          credits: {
            enabled: false
          },
          title: {
              text: ''
          },
          subtitle: {
              text: ''
          },
          xAxis: {
              categories: this.anios_aprob,
              crosshair: true
          },
          yAxis: {
              min: 0,
              title: {
                  text: 'PMF aprobados'
              }
          },
          tooltip: {
              headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
              pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                  '<td style="padding:0"><b>{point.y} PMF aprobados</b></td></tr>',
              footerFormat: '</table>',
              shared: true,
              useHTML: true
          },
          plotOptions: {
            column: {
                pointPadding: 0.2,
                borderWidth: 0
            },
            series: {
              ignoreNulls: 'fillSpace'
            }
          },
          series: this.n_data
        }
      },
      colors() {
        return {
          "Predio Privado": '#0f5106'
        }
      },
      anios_aprob() {
        return uniq(map(this.dataset, this.fieldSelected)).sort()
      },
      n_data() {
        return map(groupBy(this.dataset, 'modalidad'), (item, mod) =>  {
          return {
            name: this.$t(mod),
            color: this.colors[mod],
            data: map(this.anios_aprob, (year) => {
              return {
                name: year, 
                y: filter(item, [this.fieldSelected, year]).length
              }
            })
          }
        })
      }
    }
  }
</script>